import { Button, Card, ConfigProvider, Dropdown, Typography } from 'antd';

import { DeleteDocIcon, EditDocIcon } from '../../../assets';
import ThreeDotOutlined from '../../../assets/docchat/ThreeDotOutlined';
import styles from './ItemCard1.module.scss';

const { Text, Title, Paragraph } = Typography;

const ItemCard1 = ({ title, description, dateTime, onEdit, onDelete, onClick, className = '' }) => {
  const menuItems = [
    {
      key: 'edit',
      label: (
        <span className={styles.menuItem}>
          <EditDocIcon className={styles.menuIcon} />
          Edit Workflow
        </span>
      ),
      onClick: (e) => {
        e.domEvent.stopPropagation();
        onEdit();
      },
    },
    {
      key: 'delete',
      label: (
        <span className={styles.menuItem}>
          <DeleteDocIcon className={styles.menuIcon} />
          Delete Workflow
        </span>
      ),
      onClick: (e) => {
        e.domEvent.stopPropagation();
        onDelete();
      },
    },
  ];

  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            headerHeightSM: 58,
          },
        },
      }}
    >
      <Card
        size='small'
        className={`${className} ${styles.card}`}
        onClick={onClick}
        title={
          <>
            <Title level={5} ellipsis={{ rows: 1 }} className={styles.title}>
              {title}
            </Title>
            <Text type='secondary' className={styles.dateTime}>
              {dateTime}
            </Text>
          </>
        }
        extra={
          <Dropdown menu={{ items: menuItems }} trigger={['hover']} placement='bottomLeft'>
            <Button
              type='text'
              icon={<ThreeDotOutlined />}
              className={styles.dropdownIcon}
              onClick={(e) => e.stopPropagation()}
            />
          </Dropdown>
        }
      >
        <Paragraph ellipsis={{ rows: 3 }} className={styles.paragraph}>
          {description}
        </Paragraph>
      </Card>
    </ConfigProvider>
  );
};

export default ItemCard1;
